var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.819617 1.40983C1.47152 0.757922 2.52847 0.757922 3.18037 1.40983L11.8194 10.0489L20.4585 1.40983C21.1104 0.757922 22.1674 0.757922 22.8193 1.40983C23.4712 2.06173 23.4712 3.11868 22.8193 3.77058L12.9998 13.59C12.3479 14.2419 11.291 14.2419 10.6391 13.59L0.819617 3.77058C0.167712 3.11868 0.167712 2.06173 0.819617 1.40983Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.580854dfd322a671989a4711c846a41f.svg";
export { ForwardRef as ReactComponent };